import EventDetail from 'src/pages/Events/EventDetail.vue'
import Events from 'src/pages/Events/Events'
import EventsForm from 'src/pages/Events/EventsForm.vue'
import EventsIndex from 'src/pages/Events/EventsIndex.vue'
import TicketsDocumentation from 'src/pages/Tickets/Actions/TicketsDocumentation'
import TicketsCheckin from 'src/pages/Tickets/TicketsDetails'
import RankingIndex from 'src/pages/Ranking/RankingIndex'
import SurveysIndex from 'src/pages/Surveys/SurveysIndex'
import SurveyView from 'src/pages/Surveys/SurveyView'

const path = 'events'
const title = localStorage.getItem('eventLabel') || 'Ações'
export default {
  path: path,
  component: Events,
  children: [
    {
      path: '',
      name: `${path}.index`,
      component: EventsIndex,
      meta: {
        title: title,
        requireAuth: true
      }
    },
    {
      path: 'audit/:id',
      name: `${path}.audit`,
      component: () => import('src/pages/Events/AuditEvent.vue'),
      meta: {
        title: title,
        requireAuth: true
      }
    },
    {
      path: 'create',
      name: `${path}.create`,
      component: EventsForm,
      meta: {
        title: title,
        requireAuth: true
      }
    },
    {
      path: 'edit/:id',
      name: `${path}.edit`,
      component: EventsForm,
      meta: {
        title: title,
        requireAuth: true
      }
    },
    {
      path: 'details/:id',
      name: `${path}.details`,
      component: EventDetail,
      meta: {
        title: title,
        requireAuth: true
      }
    },
    {
      path: 'tickets/:id/documentation',
      name: `tickets.documentation`,
      component: TicketsDocumentation,
      meta: {
        title: 'Documentação do Ticket',
        requireAuth: true
      }
    },
    {
      path: '/tickets/details/:id?',
      name: `tickets.details`,
      component: TicketsCheckin,
      meta: {
        title: 'Detalhes do Ticket',
        requireAuth: true
      }
    },
    {
      path: `:id/surveys`,
      name: 'surveys.index',
      component: SurveysIndex,
      meta: {
        title: 'Pesquisas',
        requireAuth: true
      }
    },
    {
      path: `:id/surveys/:customerId`,
      name: 'surveys.view',
      component: SurveyView,
      meta: {
        title: 'Pesquisas',
        requireAuth: true
      }
    },
    {
      path: `:id/ranking`,
      name: 'ranking.index',
      component: RankingIndex,
      meta: {
        title: 'Ranking',
        requireAuth: true
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/events.js